module.exports = __webpack_public_path__ + "img/emoji_smile.1aeb8631.svg";